module.exports = __webpack_public_path__ + "img/kv-ring.2487b817.png";